"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationSalaryDeduction = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var page_path_1 = require("../../components/page_path");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var application_1 = require("../../../../api/calls/loan/application");
var react_router_dom_1 = require("react-router-dom");
var main_1 = require("../../../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var get_loan_1 = require("../../../../api/calls/loan/get_loan");
var get_user_details_1 = require("../../../../api/calls/user/get_user_details");
var react_signature_canvas_1 = __importDefault(require("react-signature-canvas"));
var firebase_file_upload_1 = require("../../../../api/calls/docs/firebase_file_upload");
var get_provider_1 = require("../../../../api/calls/loan/get_provider");
var steps_1 = require("./constants/steps");
var route_names_1 = require("../../../../constants/route_names");
var AuthorizationSalaryDeduction = function () {
    var _a, _b, _c;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_dom_1.useParams)();
    var loan_id = params.loan_id;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _d = (0, react_1.useState)(""), forceNumber = _d[0], setForceNumber = _d[1];
    var signatureRef = (0, react_1.useRef)(null);
    var _e = (0, react_1.useState)(""), signature = _e[0], setSignature = _e[1];
    var _f = (0, react_1.useState)(""), signatureURL = _f[0], setSignatureURL = _f[1];
    var _g = (0, react_1.useState)(false), isSaving = _g[0], setIsSaving = _g[1];
    var _h = (0, react_1.useState)(""), forceNumberError = _h[0], setForceNumberError = _h[1];
    var _j = (0, react_1.useState)(""), signatureError = _j[0], setSignatureError = _j[1];
    var _k = (0, react_1.useState)({}), activeLoan = _k[0], setActiveLoan = _k[1];
    var _l = (0, react_1.useState)({}), activeUser = _l[0], setActiveUser = _l[1];
    var _m = (0, react_1.useState)(""), providerName = _m[0], setProviderName = _m[1];
    (0, react_1.useEffect)(function () {
        if (loan_id) {
            (0, get_loan_1.getLoan)({ loan_id: loan_id }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var loanData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!response.success) return [3 /*break*/, 4];
                            loanData = response.content.data();
                            setActiveLoan(loanData);
                            if (!(loanData === null || loanData === void 0 ? void 0 : loanData.provider)) return [3 /*break*/, 2];
                            return [4 /*yield*/, (0, get_provider_1.getProvider)({ provider_id: loanData === null || loanData === void 0 ? void 0 : loanData.provider })
                                    .then(function (response) {
                                    var _a;
                                    if (response.success) {
                                        var providerData = response.content.data();
                                        setProviderName((_a = providerData === null || providerData === void 0 ? void 0 : providerData.name) !== null && _a !== void 0 ? _a : "Provider name not available");
                                    }
                                    else {
                                        console.error("Failed to load provider:", response.message);
                                        setProviderName("Provider information unavailable");
                                    }
                                })
                                    .catch(function (error) {
                                    console.error("Provider fetch error:", error);
                                    setProviderName("Error loading provider");
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            // Critical error - provider should have been set during loan creation
                            console.error("CRITICAL: No provider set on loan application", loanData);
                            setProviderName("ERROR: Provider not set - Please contact support");
                            dispatch((0, main_1.setMessageModal)({
                                title: "Application Error",
                                messages: ["This loan application is missing required provider information. Please contact support."],
                            }));
                            _a.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); });
        }
    }, [loan_id]);
    (0, react_1.useEffect)(function () {
        if (signatureURL) {
            saveLoanDetails();
        }
    }, [signatureURL]);
    (0, react_1.useEffect)(function () {
        if (user.uid) {
            (0, get_user_details_1.get_user_details)().then(function (response) {
                if (response.success) {
                    setActiveUser(response.content);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                }
            });
        }
    }, [user]);
    var saveLoanDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newSigURL, base64String, base64Content, byteCharacters, byteNumbers, i, byteArray, filename, file;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validateDetails()) return [3 /*break*/, 3];
                    setIsSaving(true);
                    newSigURL = "";
                    base64String = signatureURL;
                    base64Content = base64String.split(",")[1];
                    byteCharacters = atob(base64Content);
                    byteNumbers = new Array(byteCharacters.length);
                    for (i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    byteArray = new Uint8Array(byteNumbers);
                    filename = "signature_".concat(Math.random().toString(36).substring(2, 10).toUpperCase(), ".png");
                    file = new File([byteArray], filename, { type: "image/png" });
                    return [4 /*yield*/, (0, firebase_file_upload_1.uploadFileToFirebase)(file)];
                case 1:
                    newSigURL = _a.sent();
                    return [4 /*yield*/, (0, application_1.update_loan_application)({
                            uid: loan_id,
                            authoriseSalary_complete: true,
                            force_number: forceNumber,
                            salary_deduction_signature: {
                                date: new Date(),
                                signature: newSigURL,
                            },
                        }).then(function (response) {
                            if (response.success) {
                                setIsSaving(false);
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                navigate("".concat(route_names_1.ROUTE_LOAN_APPLICATION, "/").concat(steps_1.APP_STEP_AUTHORIZATION_ELECTRONIC_PAYMENTS, "/").concat(loan_id));
                                //navigate next
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                            }
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var previousStep = function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        navigate("".concat(route_names_1.ROUTE_LOAN_APPLICATION, "/").concat(steps_1.APP_STEP_DOCUMENTS, "/").concat(loan_id));
    };
    var validateDetails = function () {
        var messageCount = 0;
        // if (!forceNumber) {
        //   messageCount++;
        //   setForceNumberError("Force number is required.");
        //   window.scrollTo({
        //     top: 700,
        //     behavior: "smooth",
        //   });
        // }
        // Check if signature exists and is not empty
        if (!signatureURL) {
            messageCount++;
            setSignatureError("No signature found. Please sign before proceeding.");
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
            });
        }
        else if (signature && signature.isEmpty()) {
            messageCount++;
            setSignatureError("Signature is empty. Please draw your signature before proceeding.");
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
            });
        }
        return messageCount ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "/",
                        title: "Home",
                    },
                    {
                        page: "/loans",
                        title: "Loan Application",
                    },
                    {
                        page: "",
                        title: "Authorization Salary Deduction",
                        active: true,
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Authorization for Salary Deduction", textColor: "text-black", bold: true })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Employee Name", textColor: "text-black", size: "medium", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { disabled: true, value: activeUser === null || activeUser === void 0 ? void 0 : activeUser.name, size: "small", errorText: "", borderColor: "border-gray" })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Employee Surname", textColor: "text-black", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { disabled: true, value: activeUser === null || activeUser === void 0 ? void 0 : activeUser.surname, size: "small", errorText: "", borderColor: "border-gray" })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Employee ID Number", textColor: "text-black", size: "medium", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { disabled: true, value: activeUser === null || activeUser === void 0 ? void 0 : activeUser.id_number, size: "small", errorText: "", borderColor: "border-gray" })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Employee Phone Number", textColor: "text-black", size: "medium", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { disabled: true, value: "(".concat((_a = activeUser === null || activeUser === void 0 ? void 0 : activeUser.cell_number) === null || _a === void 0 ? void 0 : _a.country_code, ") ").concat((_b = activeUser === null || activeUser === void 0 ? void 0 : activeUser.cell_number) === null || _b === void 0 ? void 0 : _b.phone_number, " "), size: "small", errorText: "", borderColor: "border-gray" })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Force Number", textColor: "text-black", size: "medium", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { value: forceNumber, size: "small", errorText: forceNumberError, onChange: function (value) { return setForceNumber(value); } })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "1. Hereby admit, confirm and declare that:", textColor: "text-black", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "I regard the availability of credit through the Salary Deduction Agreement concluded by my Employer with", textColor: "text-black" })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Lender", textColor: "text-black", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { disabled: true, value: providerName, size: "small", errorText: "", borderColor: "border-gray" })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "(hereinafter called THE LENDER), as an Employee Benefit provided by my Employer, and the resulting deductions as duly authorized in terms thereof;", textColor: "text-black", size: "small" })),
                react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "1.1. I am of the intent to obtain credit as an Employee Benefit from THE LENDER in terms of the said Salary Deduction Agreement, and that this authorization will be instrumental in the approval by THE LENDER of such credit;", textColor: "text-black" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "1.2. That I wish to make the payments towards above-mentioned credit by way of salary deductions by my employer;", textColor: "text-black" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "1.3. That I wish my employer to assist me in every way possible to obtain this credit, and facilitate the said payments by way of salary deductions;", textColor: "text-black" })),
                react_1.default.createElement(doshx_controls_web_1.DividerControl, { orientation: "horizontal" }),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "2. Therefore, I irrevocably order and authorize my present employer,", textColor: "text-black", bold: true })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your Employer", textColor: "text-black", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { disabled: true, value: (_c = activeUser === null || activeUser === void 0 ? void 0 : activeUser.employment_details) === null || _c === void 0 ? void 0 : _c.employer, size: "small", errorText: "", borderColor: "border-gray" })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "(NAME OF EMPLOYER AS ON PAYSLIP) as well as all of my future employers:", textColor: "text-black", size: "small" })),
                react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "2.1. To deduct the payment amounts as submitted for payment by THE LENDER to my employer, at the time and in the amounts as requested by THE LENDER, from my next salary/salaries and/or any other amounts payable to me, and pay the said amounts over to the above-mentioned THE LENDER;", textColor: "text-black" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "2.2. To provide THE LENDER, now and in future, with all required information regarding my person, including personal, financial, employment, banking and credit information;", textColor: "text-black" })),
                react_1.default.createElement(doshx_controls_web_1.DividerControl, { orientation: "horizontal" }),
                react_1.default.createElement("div", { className: "flex flex-col items-center gap-2" },
                    react_1.default.createElement("div", { className: "flex flex-col border gap-2 border-gray-400 rounded-md ", style: { width: 300 } },
                        react_1.default.createElement(react_signature_canvas_1.default, { ref: function (data) {
                                setSignature(data);
                            }, canvasProps: { height: 150, width: 300, className: "sigCanvas" } })),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: signatureError, textColor: "text-red-500" }),
                    react_1.default.createElement("div", { className: "flex justify-center gap-2" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Clear", backgroundColor: "bg-primary", size: "xsmall", loading: isSaving, enabled: !isSaving, onClick: function () {
                                signature.clear();
                                setSignatureURL("");
                            } })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("img", { width: 100, src: signatureURL }))),
                react_1.default.createElement("div", { className: "flex justify-center gap-4 " },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", loading: isSaving, enabled: !isSaving, backgroundColor: "bg-primary", size: "small", startIcon: pro_solid_svg_icons_1.faArrowLeft, onClick: function () {
                            previousStep();
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save & Proceed", backgroundColor: "bg-secondary", size: "small", loading: isSaving, enabled: !isSaving, endIcon: pro_solid_svg_icons_1.faArrowRight, onClick: function () {
                            // Check if signature canvas is empty BEFORE converting to base64
                            if (signature && signature.isEmpty()) {
                                setSignatureError("Please draw your signature before proceeding.");
                                window.scrollTo({
                                    top: document.body.scrollHeight,
                                    behavior: "smooth",
                                });
                                return;
                            }
                            // Clear previous error
                            setSignatureError("");
                            // Convert signature to base64 and trigger save
                            setSignatureURL(signature.getTrimmedCanvas().toDataURL("image/png"));
                        } }))))));
};
exports.AuthorizationSalaryDeduction = AuthorizationSalaryDeduction;
